// extracted by mini-css-extract-plugin
var _1 = "roundedButton-module__roundedButton___bg9Iq";
export { _1 as "roundedButton" }
